import { Button } from "@/shared/components/ui/button";
import { cn } from "@/shared/lib/utils";
import { CONTACT_SALES_URL } from "../constants";
import { usePostHog } from "@posthog/react";

type ContactSalesButtonProps = {
  className?: string;
};

export function ContactSalesButton({ className }: ContactSalesButtonProps) {
  const posthog = usePostHog();

  return (
    <Button asChild variant="default" className={cn(className)}>
      <a
        href={CONTACT_SALES_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => posthog.capture("contact_sales_clicked")}
      >
        Contact Sales
      </a>
    </Button>
  );
}
